import clsx from 'clsx'
import initials from 'initials'
import PropTypes from 'prop-types'

/**
 * Atomic Component: TalentBadge
 * Displays a colored badge with talent initials
 */
const TalentBadge = ({ name, className, size = 'md' }) => {
  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-base',
    lg: 'text-lg'
  }

  return (
    <div
      className={clsx('relative flex items-center justify-center', className)}
    >
      <svg
        width={size === 'sm' ? '32px' : size === 'lg' ? '48px' : '40px'}
        height={size === 'sm' ? '32px' : size === 'lg' ? '48px' : '40px'}
        viewBox={`0 0 ${size === 'sm' ? '32' : size === 'lg' ? '48' : '40'} ${size === 'sm' ? '32' : size === 'lg' ? '48' : '40'}`}
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <defs>
          <rect
            id='path-q2p7ht6fw3-1'
            x='0'
            y='0'
            width={size === 'sm' ? '32' : size === 'lg' ? '48' : '40'}
            height={size === 'sm' ? '32' : size === 'lg' ? '48' : '40'}
            rx='10'
          />
        </defs>
        <g
          id='Page-1'
          stroke='none'
          strokeWidth='1'
          fill='none'
          fillRule='evenodd'
        >
          <g id='Group'>
            <rect
              id='Rectangle'
              fill='#29CCC7'
              fillRule='nonzero'
              x='0'
              y='0'
              width={size === 'sm' ? '32' : size === 'lg' ? '48' : '40'}
              height={size === 'sm' ? '32' : size === 'lg' ? '48' : '40'}
              rx='10'
            />
            <g id='Clipped'>
              <mask id='mask-q2p7ht6fw3-2' fill='white'>
                <use xlinkHref='#path-q2p7ht6fw3-1' />
              </mask>
              <g id='Rectangle' />
              <g id='Group' mask='url(#mask-q2p7ht6fw3-2)' fillRule='nonzero'>
                <g transform='translate(-37.000000, -3.000000)' id='Oval'>
                  <circle fill='#A2E3FF' cx='33' cy='50' r='33' />
                  <circle fill='#4D7BF3' cx='86.5' cy='42.5' r='42.5' />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <span
        className={clsx(
          'absolute font-semibold uppercase text-white',
          textSizeClasses[size]
        )}
      >
        {initials(name || '').slice(0, 2)}
      </span>
    </div>
  )
}

TalentBadge.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
}

export default TalentBadge
